<div class="kcs-card">
  <div class="d-flex flex-row">
    <h5>{{ 'profile.title' | translate }}</h5>
  </div>
  <p-divider />
  @if(user){
    <div class="user-profile-container">
      <!-- Header Section -->
      <div styleClass="profile-header-card">
        <div class="profile-header">
          <div class="avatar-section">
            <p-avatar [label]="configService.getUsernameInitials()" size="xlarge" styleClass="profile-avatar" shape="circle" [style]="{ background: configService.getColorFromDisplayName() }"> </p-avatar>
          </div>

          <div class="profile-info">
            <div class="name-section">
              <h2 class="profile-name">{{ user.usr_firstname }} {{ user.usr_lastname }}</h2>
              <span class="username">&#64;{{ user.usr_displayname }}</span>
            </div>

            <div class="profile-stats">
              <div class="stat-item">
                <span class="stat-number">{{ getActiveRolesCount() }}</span>
                <span class="stat-label">{{ 'profile.roles' | translate }}</span>
              </div>
              <div class="stat-item">
                <span class="stat-number">{{ getActivePortalsCount() }}</span>
                <span class="stat-label">{{ 'profile.portals' | translate }}</span>
              </div>
            </div>
          </div>

          <!--div class="profile-actions">
          <p-button [label]="isEditMode ? 'Save' : 'Edit Profile'" [icon]="isEditMode ? 'pi pi-check' : 'pi pi-pencil'" (onClick)="toggleEditMode()" [severity]="isEditMode ? 'success' : 'secondary'"> </p-button>
          <p-button *ngIf="isEditMode" label="Cancel" icon="pi pi-times" severity="secondary" [text]="true" (onClick)="cancelEdit()"> </p-button>
        </div-->
      </div>
    </div>

    <!-- Tabbed Content -->
    <p-tabs [value]="0" styleClass="profile-tabs">
      <p-tablist>
        <p-tab [value]="0"><i class="pi pi-user" style="margin-right: 0.5rem" aria-hidden="true"></i>{{ 'profile.settings.tab.profile-tab' | translate }}</p-tab>
        <p-tab [value]="1"><i class="pi pi-users" style="margin-right: 0.5rem" aria-hidden="true"></i>{{ 'profile.settings.tab.role-tab' | translate }}</p-tab>
        <p-tab [value]="2"><i class="pi pi-globe" style="margin-right: 0.5rem" aria-hidden="true"></i>{{ 'profile.settings.tab.portals-tab' | translate }}</p-tab>
        <p-tab [value]="3"><i class="pi pi-cog" style="margin-right: 0.5rem" aria-hidden="true"></i>{{ 'profile.settings.tab.settings-tab' | translate }}</p-tab>
      </p-tablist>
      <p-tabpanels>
        <!-- Personal Information Tab -->
        <p-tabpanel [value]="0">
          <p-card>
            <div class="form-grid">
              <div class="form-row">
                <div class="form-field">
                  <label for="firstName">{{ 'profile.firstname' | translate }}</label>
                  <input id="firstName" type="text" pInputText [(ngModel)]="editableUser.usr_firstname" [readonly]="!isEditMode" [class.readonly]="!isEditMode" />
                </div>
                <div class="form-field">
                  <label for="lastName">{{ 'profile.lastname' | translate }}</label>
                  <input id="lastName" type="text" pInputText [(ngModel)]="editableUser.usr_lastname" [readonly]="!isEditMode" [class.readonly]="!isEditMode" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-field">
                  <label for="email">{{ 'profile.email' | translate }}</label>
                  <input id="email" type="email" pInputText [(ngModel)]="editableUser.usr_mail" [readonly]="!isEditMode" [class.readonly]="!isEditMode" />
                </div>
                <div class="form-field">
                  <label for="phone">{{ 'profile.phone' | translate }}</label>
                  <input id="phone" type="tel" pInputText [(ngModel)]="editableUser.usr_phone" [readonly]="!isEditMode" [class.readonly]="!isEditMode" />
                </div>
              </div>

              <!--div class="form-row">
              <div class="form-field">
                <label for="department">Department</label>
                <input id="department" type="text" pInputText [(ngModel)]="editableUser.department" [readonly]="!isEditMode" [class.readonly]="!isEditMode" />
              </div>
            </div-->
          </div>
        </p-card>
      </p-tabpanel>

      <!-- Roles Tab -->
      <p-tabpanel [value]="1">
        <p-card>
          <div class="roles-section">
            <h4>{{ 'profile.assigned_roles' | translate }}</h4>
            <p class="section-description">{{ 'profile.assigned_roles.description' | translate }}</p>

            <div class="roles-grid">
              @for (role of assignedRoles; track role) {
                <div class="role-card" [class.active]="role.rl_isChecked">
                  <div class="role-header">
                    <div>
                      <h5>{{ role.rl_name }}</h5>
                      <p-tag [value]="role.rl_type" [severity]="getRoleSeverity(role.rl_type)" styleClass="role-type-tag"> </p-tag>
                    </div>
                  </div>
                  <p class="role-description">{{ role.rl_description }}</p>
                  <div class="role-meta">
                    <small>{{ 'profile.assigned_roles.role_id' | translate }}: {{ role.rl_id }}</small>
                  </div>
                </div>
              }
            </div>

            <div class="roles-summary">
              <div class="summary-item">
                <span class="summary-label">{{ 'profile.assigned_roles.active_roles' | translate }}:</span>
                <p-badge [value]="getActiveRolesCount()" severity="success"></p-badge>
              </div>
            </div>
          </div>
        </p-card>
      </p-tabpanel>

      <!-- Portals Tab -->
      <p-tabpanel [value]="2">
        <p-card>
          <div class="portals-section">
            <h4>{{ 'profile.assigned_portals' | translate }}</h4>
            <p class="section-description">{{ 'profile.assigned_portals.description' | translate }}</p>

            <p-table [value]="assignedPortals || []" [paginator]="true" [rows]="5" styleClass="portals-table">
              <ng-template pTemplate="header">
                <tr>
                  <th>{{ 'profile.assigned_portals.table.portal' | translate }}</th>
                  <th>{{ 'profile.assigned_portals.table.description' | translate }}</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-portal>
                <tr>
                  <td>
                    <div class="portal-info">
                      <div class="portal-icon">
                        <i class="pi pi-globe"></i>
                      </div>
                      <div>
                        <small class="portal-meta">ID: {{ portal.pt_id }}</small>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span class="portal-description" [pTooltip]="portal.pt_descrizione" tooltipPosition="top"> {{ portal.pt_descrizione | slice : 0 : 50 }}{{ portal.pt_descrizione.length > 50 ? '...' : '' }} </span>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="2" class="text-center">{{ 'profile.assigned_portals.table.noportal' | translate }}</td>
                </tr>
              </ng-template>
            </p-table>

            <div class="portals-summary">
              <div class="summary-grid">
                <div class="summary-card">
                  <h5>{{ 'profile.assigned_portals.active_portals' | translate }}</h5>
                  <span class="big-number">{{ getActivePortalsCount() }}</span>
                </div>
              </div>
            </div>
          </div>
        </p-card>
      </p-tabpanel>

      <!-- Settings Tab -->
      <p-tabpanel [value]="3">
        <p-card>
          <div class="settings-section">
            <h4>{{ 'profile.settings.preferences' | translate }}</h4>

            <div class="form-grid">
              <div class="form-row">
                <div class="form-field">
                  <label for="notifications">{{ 'profile.settings.preferences.email_notification' | translate }}</label>
                  <p-toggleButton id="notifications" [(ngModel)]="editableUser.emailNotifications" onLabel="Enabled" offLabel="Disabled" [disabled]="!isEditMode"> </p-toggleButton>
                </div>
              </div>
            </div>

            <p-divider></p-divider>

            <div class="account-info">
              <h4>{{ 'profile.settings.preferences.account_Information' | translate }}</h4>
              <div class="info-item">
                <span class="label">{{ 'profile.settings.preferences.account_Information.user_id' | translate }}:</span>
                <p-badge [value]="user.usr_id.toString()"></p-badge>
              </div>
              <div class="info-item">
                <span class="label">Username:</span>
                <span class="value">{{ user.usr_username }}</span>
              </div>
            </div>
          </div>
        </p-card>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>

}
</div>
